export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets200_strips250_scale_cuff_gray@2x.82763d73.webp";